{
  "version": 1,
  "asset_id": "f4022b39-61d2-446d-bbee-11760ae0b7a6",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/f4022b39-61d2-446d-bbee-11760ae0b7a6/cleaning-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/f4022b39-61d2-446d-bbee-11760ae0b7a6/cleaning-thumb.webp",
  "original_filename": "cleaning-thumb.webp",
  "size": 3138,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:24:53Z"
}
